import type { Address } from "viem"
import type { Config } from "wagmi"

import type { EmitEvent } from "@/domains/core"
import type { IEventBus } from "@/domains/events"
import type { EventEmitter } from "@/domains/library"
import { revokeSuperVoterForAll } from "@/domains/on-chain"
import { SuperVoterAccessRevokedEvent } from "@/domains/vote-page/events"

interface MaxLockInteractionParams {
  account: Address
  chainId: number
  config: Config
  vestedAddress: Address
  superVoterAddress: Address
  emitter: EventEmitter<EmitEvent>
  eventBus: IEventBus
}

export const revokeSuperVoterForAllInteraction = async ({
  account,
  chainId,
  config,
  vestedAddress,
  superVoterAddress,
  emitter,
  eventBus,
}: MaxLockInteractionParams) => {
  const result = await revokeSuperVoterForAll({
    account,
    chainId,
    config,
    vestedAddress,
    superVoterAddress,
  })

  if (result.success) {
    // Emit domain event for orchestrator to refresh access state
    eventBus.publish(new SuperVoterAccessRevokedEvent(account, result.tx))
    // Emit user notification
    emitter.emit("revoke-super-voter-for-all", {
      title: "SuperVoter access",
      description: `SuperVoter access revoked`,
      variant: "success",
    })
  }

  if (result.success === false) {
    emitter.emit("error-revoke-super-voter-for-all", {
      title: "SuperVoter access failed",
      description: `Unable to revoke access to the SuperVoter, reason ${result.error}`,
      variant: "error",
    })
  }

  return result
}
